import { Box, FormControl } from '@chakra-ui/react';
import React from 'react';

import { CreditAgreement } from '@finley-technologies/finley-types';

import { ConcentrationCalcFieldLabel } from './ConcentrationCalcFieldLabel';
import { FieldSelector } from './FieldSelector';
import { makeSelectOptions } from './makeSelectOptions';
import { Select } from 'packages/common-frontend/components/Select';

export const WeightingTypeEditor = ({
  value,
  onChange,
}: {
  value: CreditAgreement.Config.ConcentrationLimit.Calculation.Weighting;
  onChange: (
    newValue: CreditAgreement.Config.ConcentrationLimit.Calculation.Weighting,
  ) => void;
}) => {
  const selectOptions = makeSelectOptions(
    CreditAgreement.Config.ConcentrationLimit.Calculation.WeightingIterable,
  );

  return (
    <FormControl mb={4}>
      <ConcentrationCalcFieldLabel
        m={1}
        label="Weighting"
        tooltip={`Select which field to use as the weight. Exposure is the common weight for weighted average. Choose "constant" for a simple average.`}
      />

      <Select<CreditAgreement.Config.ConcentrationLimit.Calculation.Weighting>
        value={value}
        onChange={(val) => {
          if (val) {
            onChange(val);
          }
        }}
        options={selectOptions}
      />
    </FormControl>
  );
};

export const LimitTypeEditor = ({
  value,
  onChange,
}: {
  value: CreditAgreement.Config.ConcentrationLimit.Calculation.LimitType;
  onChange: (
    newValue: CreditAgreement.Config.ConcentrationLimit.Calculation.LimitType,
  ) => void;
}) => {
  const selectOptions = makeSelectOptions(
    CreditAgreement.Config.ConcentrationLimit.Calculation.LimitTypeIterable,
  );

  return (
    <FormControl mb={4}>
      <ConcentrationCalcFieldLabel
        m={1}
        label="Limit Type"
        tooltip="min or max"
      />

      <Select<CreditAgreement.Config.ConcentrationLimit.Calculation.LimitType>
        value={value}
        onChange={(val) => {
          if (val) {
            onChange(val);
          }
        }}
        options={selectOptions}
      />
    </FormControl>
  );
};

export const WeightedAverageConfigEditor = ({
  availableFields,
  value,
  onChange,
}: {
  availableFields: CreditAgreement.Config.ConcentrationLimit.Calculation.AvailableField[];
  value: CreditAgreement.Config.ConcentrationLimit.Calculation.DeclarativeFilterWeightedAverageCalculationConfig;
  onChange: (
    newValue: CreditAgreement.Config.ConcentrationLimit.Calculation.DeclarativeFilterWeightedAverageCalculationConfig,
  ) => void;
}) => {
  return (
    <Box mb={4}>
      <LimitTypeEditor
        value={value.limitType}
        onChange={(newValue) => {
          onChange({
            ...value,
            limitType: newValue,
          });
        }}
      />
      <FormControl>
        <ConcentrationCalcFieldLabel
          m={1}
          label="Field"
          tooltip="Select the field to use for calculating the weighted average."
        />
        <FieldSelector
          availableFields={availableFields}
          allowedTypes={['float', 'integer']}
          initialField={value.config.field}
          onSelectedFieldChange={(field) =>
            onChange({
              ...value,
              config: {
                ...value.config,
                field,
              },
            })
          }
        />
      </FormControl>
      <WeightingTypeEditor
        value={value.config.weighting}
        onChange={(newValue) => {
          onChange({
            ...value,
            config: {
              ...value.config,
              weighting: newValue,
            },
          });
        }}
      />
    </Box>
  );
};
